import React from "react"
import CustomTable from "../components/CustomTable";
import { activeAndInactiveUserUpdateStatus, deleteUserDetails, getAllUsers } from '../services/ApiServices'
import famileeTreeProfile from "../images/images.png"
import { DeleteButton } from "../components/masterDataForm/DeleteButton";
import { ActiveAndInactive } from "../components/ActiveAndInactive";
import { useDispatch, useSelector } from "react-redux";
import { DeleteConfirmDialog } from "../components/userForm/DeleteUser";
import { toast } from "react-toastify";

const User = () => {
    const message = `Are you sure you want to delete this user?`;
    const [deleteConfirmDailogShow, setDeleteConfirmDailogShow] = React.useState(false);
    const [userId, setUserId] = React.useState();
    const [pageNo, setPageNo ] = React.useState(1);
    const [pageSize, setPageSize ] = React.useState(10);
    const [totalPages, setTotalPages ] = React.useState(0);
    const dispatch = useDispatch()
    const userInfo = useSelector(state => state?.getAllUsers?.users);


    React.useEffect(() => {
        const fetchUsers = async () => {
            try {
                const res = await getAllUsers();
                if(res.status === 200) {
                    dispatch({ type: 'GET_ALL_USERS', payload: res.data.data.data })
                    setTotalPages(res.data.data.totalUsers)
                }
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };
        fetchUsers();
    }, [dispatch]);


    const deleteUserHandle = async () => {
        try {
            const deleteUserRes = await deleteUserDetails(userId);
            if(deleteUserRes.status === 200) {
                dispatch({ type: 'DELETE_USERS', payload: deleteUserRes.data?.data})
                toast.success(deleteUserRes.data?.message)
                setDeleteConfirmDailogShow(false)
                return
            }
        } catch (error) {
            toast.error('Something Wrong')
        }
    };

    const userActiveInactiveHandle = async (userId) => {
        try {
            const activeAndInactiveUserStatus = await activeAndInactiveUserUpdateStatus(userId);
            if(activeAndInactiveUserStatus.status === 200) {
                dispatch({ type: 'UPDATE_USER_ACTIVE_INACTIVE_STATUS', payload: activeAndInactiveUserStatus.data?.data})
                toast.success(activeAndInactiveUserStatus.data?.message)
            }
        } catch (error) {
            toast.error('Something Wrong')
        }
    };

    const colDefs = [
            { field: "profileImage", flex: 1, filter: false, headerName: 'Profile', cellRenderer: (item) => {
                return  item.value ? <img src={item?.value} alt="" width={50} height={50} style={{borderRadius: "100%"}}/> : <img src={famileeTreeProfile} alt="" width={50} height={50} style={{borderRadius: "100%"}}/>
              } },
            { field: "firstName", flex: 1.2, headerName: 'First Name'},
            { field: "lastName", flex: 1.2, headerName: 'Last Name' },
            { field: "emailId", flex: 2, headerName: 'Email' },
            { field: "dateOfBirth", flex: 1.2, headerName: 'Date OF Birth', valueFormatter: (params) => {
                const date = new Date(params?.value);
                if (isNaN(date.getTime())) {
                    return "Invalid Date"; 
                }
                return date.toISOString().split('T')[0];
            } },
            { field: "createdAt", flex: 1.2, headerName: 'Created Date', valueFormatter: (params) => {
                const date = new Date(params.value);
                if (isNaN(date.getTime())) {
                    return "Invalid Date"; 
                }
                return date.toISOString().split('T')[0];
            }},
            { field: "isActive", flex: 1.5, filter: false, headerName: 'Status', cellRenderer: (val) => ( <ActiveAndInactive status={val?.data?.isActive} statusId={val.data._id} handleActiveAndInActive={userActiveInactiveHandle}/> )},
            { field: '_id', flex: 1, filter: false, headerName: 'Action', cellRenderer: (val) => (<DeleteButton statusId={val.data._id} setId={setUserId} setShowDeleteConfirmPop={setDeleteConfirmDailogShow} />)}
        ];

    return(
        <React.Fragment>
            <div className="aside-heading">
                <h3>USERS</h3>
            </div>
            <CustomTable colDefs={colDefs} rowData={userInfo} pageNo={pageNo} setPageNo={setPageNo} pageSize={pageSize} setPageSize={setPageSize} totalPages={totalPages} setTotalPages={setTotalPages}/>
            <DeleteConfirmDialog formName="User" message={message} handleDelete={deleteUserHandle} showDeleteConfirmPop={deleteConfirmDailogShow} setShowDeleteConfirmPop={setDeleteConfirmDailogShow}/>
        </React.Fragment>
    )
};
export default User;